<ejs-dialog target=".dialogs" class="simple-dialog e-dlg-fullscreen" [visible]='visible' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [zIndex]="999" [showCloseIcon]="false" (beforeClose)="close()">
  <ng-template #header>
    <div class="d-flex justify-content-end justify-content-md-between align-items-center w-100">
      <div class="align-items-center d-none d-md-flex gap-2">
        <app-icon-badge [style]="'default'" [icon]="'draft'" [fontSize]="'fs-5'"></app-icon-badge>
        <app-headline [title]="documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].filename!" [type]="'h6'" [class]="'fs-small truncate-text-two-lines'"></app-headline>
        @if (showChatOptions) {
          <app-headline [title]="(currentGalleryMessage()?.created_at | date : 'shortTime') ?? ''" [type]="'h6'" [class]="'fs-small truncate-text-two-lines'"></app-headline>
          @if (isGroupChatContext()) {
            <app-form-button
              [style]="'btn'"
              [cssClass]="'btn-link text-muted p-1 fs-small gallery-read-count-button'"
              [icon]="'visibility'"
              [iconClass]="'fs-5'"
              [textClass]="'fs-small'"
              (click)="openReadsDialog()"
              [text]="(currentGalleryMessage()?.read_count ?? 0) > 0 ? (currentGalleryMessage()!.read_count.toString()) : ''">
            </app-form-button>
          }
        }
      </div>
      <div class="gallery-mobile-meta d-flex d-md-none flex-column justify-content-center pe-2">
        <div class="d-flex align-items-center gap-2">
          <app-icon-badge [style]="'default'" [icon]="'draft'" [fontSize]="'fs-6'"></app-icon-badge>
          <app-headline [title]="documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].filename!" [type]="'h6'" [class]="'fs-small truncate-text-two-lines mb-0'"></app-headline>
        </div>
        @if (showChatOptions) {
          <div class="d-flex align-items-center gap-2 pt-1">
            <app-headline [title]="(currentGalleryMessage()?.created_at | date : 'shortTime') ?? ''" [type]="'h6'" [class]="'fs-verysmall text-muted mb-0'"></app-headline>
            @if (isGroupChatContext()) {
              <div class="d-flex align-items-center text-muted gap-1 gallery-read-count-mobile cursor-pointer" (click)="openReadsDialog()">
                <app-icon-badge [style]="'default'" [icon]="'visibility'" [fontSize]="'fs-6'" [fontColor]="'text-muted'"></app-icon-badge>
                <span class="fs-verysmall">{{ currentGalleryMessage()?.read_count ?? 0 }}</span>
              </div>
            }
          </div>
        }
      </div>
      <div class="d-none d-md-flex align-items-center p-1 gap-1 mb-1">
        @if (showChatOptions) {
          <app-tooltip [text]="'GALLERYREPLYIMAGETOOLTIP' | translate" [width]="'auto'" [height]="'auto'">
          <app-form-button
            [style]="'btn'"
            [cssClass]="'btn-link text-muted p-1'"
            [iconClass]="'fs-5'"
            [icon]="'reply'"
            (click)="reply()">
          </app-form-button>
        </app-tooltip>

        <app-tooltip [text]="'GALLERYSTARIMAGETOOLTIP' | translate" [width]="'auto'" [height]="'auto'">
          <app-form-button
            [style]="'btn'"
            [cssClass]="'btn-link text-muted p-1'"
            [iconClass]="isCurrentMessageFavorite() ? 'fs-5 mts-icon-filled text-warning' : 'fs-5'"
            [icon]="'star'"
            (click)="star()">
          </app-form-button>
        </app-tooltip>

        <app-tooltip [text]="'GALLERYPINIMAGETOOLTIP' | translate" [width]="'auto'" [height]="'auto'">
          <app-form-button
            [style]="'btn'"
            [cssClass]="'btn-link text-muted p-1'"
            [iconClass]="'fs-5'"
            [icon]="'keep'"
            (click)="keep()">
          </app-form-button>
        </app-tooltip>

        <app-tooltip [text]="'GALLERYDELETEIMAGETOOLTIP' | translate" [width]="'auto'" [height]="'auto'">
          <app-form-button
            [style]="'btn'"
            [cssClass]="'btn-link text-muted p-1'"
            [iconClass]="'fs-5'"
            [icon]="'delete'"
            (click)="delete()">
          </app-form-button>
        </app-tooltip>

        <app-tooltip [text]="'GALLERYFORWARDIMAGETOOLTIP' | translate" [width]="'auto'" [height]="'auto'">
          <app-form-button
            [style]="'btn'"
            [cssClass]="'btn-link text-muted p-1'"
            [iconClass]="'fs-5'"
            [icon]="'forward'"
            (click)="forward()">
          </app-form-button>
        </app-tooltip>

        }

      @if(!hideReactions) {
        <app-emoji-pill
          [emojis]="reactionEntries()"
          (deleteEmoji)="onEmojiPillDelete($event)"
        >
        </app-emoji-pill>
        <app-reaction-picker [enableCustomEmoji]="true" (selection)="onReactionSelection($event)">
          <app-tooltip [text]="'GALLERYREACTIONTOOLTIP' | translate" [width]="'auto'" [height]="'auto'">
            <app-form-button [style]="'btn'" [cssClass]="'btn-link text-muted p-1 pt-2'" [icon]="'mood'" [iconClass]="'fs-5'"></app-form-button>
          </app-tooltip>
        </app-reaction-picker>
      }
      <ejs-tooltip [opensOn]="'Auto'" [animation]="dialogService.getTooltipAnimation()" [position]="'TopCenter'" [width]="'420px'" [cssClass]="'gallery-file-info-tooltip p-2'">
        <app-form-button
          [style]="'btn'"
          [cssClass]="'btn-link text-muted p-1'"
          [iconClass]="'fs-5'"
          [icon]="'info'">
        </app-form-button>
        <ng-template #content>
          <div class="text-default">
            <div class="fs-default">
              <span class="fw-bold">{{ ('DOCUMENTFILENAME' | translate) }}:</span>
            </div>
            <span>{{ currentGalleryFile().filename }}</span>

            <div class="my-1">
              <span class="fs-default fw-bold pe-1">{{ ('DOCUMENTSIZE' | translate) }}:</span>
              <span>{{ currentGalleryFile().size! | fileSize }}</span>
            </div>
            <div>
              <span class="fs-default fw-bold pe-1">{{ ('DOCUMENTTYPE' | translate) }}:</span>
              <span class="text-uppercase">{{ documentService.getDocumentExtension(currentGalleryFile()) }}</span>
            </div>
          </div>
        </ng-template>
      </ejs-tooltip>
      <app-tooltip [text]="'GALLERYDOWNLOADIMAGETOOLTIP' | translate" [width]="'auto'" [height]="'auto'">
        <app-form-button
          [style]="'btn'"
          [cssClass]="'btn-link text-muted p-1'"
          [iconClass]="'fs-5'"
          [icon]="'download'"
          (click)="downloadCurrentFile()">
        </app-form-button>
      </app-tooltip>

      <!--<app-tooltip [text]="'GALLERYEXTERNALLINKTOOLTIP' | translate" [width]="'auto'" [height]="'auto'">
      <app-form-button
        [style]="'btn'"
        [cssClass]="'btn-link text-muted p-1'"
        [iconClass]="'fs-5'"
        [icon]="'link'"
        (click)="linkDialog = !linkDialog; infoDialog = false;">
      </app-form-button>
    </app-tooltip>

    <app-tooltip [text]="'GALLERYIMAGEINFOTOOLTIP' | translate" [width]="'auto'" [height]="'auto'">
      <app-form-button
        [style]="'btn'"
        [cssClass]="'btn-link text-muted p-1'"
        [iconClass]="'fs-5'"
        [icon]="'info'"
        (click)="infoDialog = !infoDialog; linkDialog = false;">
      </app-form-button>
    </app-tooltip>-->

    <app-tooltip [text]="'CLOSE' | translate" [width]="'auto'" [height]="'auto'">
      <app-form-button (click)="close()" [style]="'btn'" [cssClass]="'btn-close ps-2'"></app-form-button>
    </app-tooltip>
  </div>
  <div class="d-flex d-md-none align-items-center p-1 gap-1 mb-1">
    <div class="dropdown">
        <button #mobileMenuToggle type="button" class="btn btn-link text-muted p-1 gallery-mobile-menu-toggle" data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
          <app-icon-badge [style]="'default'" [icon]="'more_vert'" [fontSize]="'fs-5'"></app-icon-badge>
        </button>
      <ul class="dropdown-menu dropdown-menu-end gallery-mobile-dropdown-menu">
        @if (showChatOptions) {
          <li><button type="button" class="dropdown-item d-flex align-items-center gap-2" (click)="reply()"><app-icon-badge [style]="'default'" [icon]="'reply'" [fontSize]="'fs-6'"></app-icon-badge><span>{{ ('REPLY' | translate) }}</span></button></li>
          <li><button type="button" class="dropdown-item d-flex align-items-center gap-2" (click)="star()"><app-icon-badge [style]="'default'" [icon]="'star'" [fontSize]="'fs-6'"></app-icon-badge><span>{{ ('STAR' | translate) }}</span></button></li>
          <li><button type="button" class="dropdown-item d-flex align-items-center gap-2" (click)="keep()"><app-icon-badge [style]="'default'" [icon]="'keep'" [fontSize]="'fs-6'"></app-icon-badge><span>{{ ('PIN' | translate) }}</span></button></li>
          <li><button type="button" class="dropdown-item d-flex align-items-center gap-2" (click)="delete()"><app-icon-badge [style]="'default'" [icon]="'delete'" [fontSize]="'fs-6'"></app-icon-badge><span>{{ ('DELETE' | translate) }}</span></button></li>
          <li><button type="button" class="dropdown-item d-flex align-items-center gap-2" (click)="forward()"><app-icon-badge [style]="'default'" [icon]="'forward'" [fontSize]="'fs-6'"></app-icon-badge><span>{{ ('FORWARD' | translate) }}</span></button></li>
        }
        <li>
          <ejs-tooltip [opensOn]="'Auto'" [animation]="dialogService.getTooltipAnimation()" [position]="'TopCenter'" [width]="'420px'" [cssClass]="'gallery-file-info-tooltip p-2'">
            <button type="button" class="dropdown-item d-flex align-items-center gap-2 gallery-mobile-file-info">
              <app-icon-badge [style]="'default'" [icon]="'info'" [fontSize]="'fs-6'"></app-icon-badge>
              <span>{{ ('INFO' | translate) === 'INFO' ? 'Info' : ('INFO' | translate) }}</span>
            </button>
            <ng-template #content>
              <div class="text-default">
                <div class="fs-default">
                  <span class="fw-bold">{{ ('DOCUMENTFILENAME' | translate) }}:</span>
                </div>
                <span>{{ currentGalleryFile().filename }}</span>

                <div class="my-1">
                  <span class="fs-default fw-bold pe-1">{{ ('DOCUMENTSIZE' | translate) }}:</span>
                  <span>{{ currentGalleryFile().size! | fileSize }}</span>
                </div>
                <div>
                  <span class="fs-default fw-bold pe-1">{{ ('DOCUMENTTYPE' | translate) }}:</span>
                  <span class="text-uppercase">{{ documentService.getDocumentExtension(currentGalleryFile()) }}</span>
                </div>
              </div>
            </ng-template>
          </ejs-tooltip>
        </li>
        <li><button type="button" class="dropdown-item d-flex align-items-center gap-2" (click)="downloadCurrentFile()"><app-icon-badge [style]="'default'" [icon]="'download'" [fontSize]="'fs-6'"></app-icon-badge><span>{{ ('DOWNLOAD' | translate) === 'DOWNLOAD' ? 'Download' : ('DOWNLOAD' | translate) }}</span></button></li>
        @if(!hideReactions) {
          @if (reactionEntries().length > 0) {
            <li><button type="button" class="dropdown-item d-flex align-items-center gap-2" (click)="openMobileReactionsOverview(mobileEmojiPill)"><app-icon-badge [style]="'default'" [icon]="'groups'" [fontSize]="'fs-6'"></app-icon-badge><span>{{ ('CHATEMOJILISTTITLE' | translate) === 'CHATEMOJILISTTITLE' ? 'Reactions' : ('CHATEMOJILISTTITLE' | translate) }}</span></button></li>
          }
          <li>
            <app-reaction-picker [enableCustomEmoji]="true" [triggerDisplay]="'block'" (selection)="onReactionSelection($event)">
              <button type="button" class="dropdown-item d-flex align-items-center gap-2">
                @if (currentReactionEmoji(); as reactionEmoji) {
                  <span class="gallery-mobile-reaction-emoji">{{ reactionEmoji }}</span>
                } @else {
                  <app-icon-badge [style]="'default'" [icon]="'mood'" [fontSize]="'fs-6'"></app-icon-badge>
                }
                <span>{{ ('REACTION' | translate) === 'REACTION' ? 'Reaction' : ('REACTION' | translate) }}</span>
              </button>
            </app-reaction-picker>
          </li>
        }
      </ul>
      <app-emoji-pill
        #mobileEmojiPill
        class="d-none"
        [emojis]="reactionEntries()"
        (deleteEmoji)="onEmojiPillDelete($event)">
      </app-emoji-pill>
    </div>
    <app-tooltip [text]="'CLOSE' | translate" [width]="'auto'" [height]="'auto'">
      <app-form-button (click)="close()" [style]="'btn'" [cssClass]="'btn-close ps-2'"></app-form-button>
    </app-tooltip>
  </div>
</div>
</ng-template>
<ng-template #content>
  <div class="d-flex flex-column h-100 align-items-center justify-content-center position-relative bg-black">
    <div class="imagepreview-fullscreen">

      @if (documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].type === 'image' && documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].mimetype !== 'image/gif') {
        <img #imagePreviewElement
          [ngSrc]="documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].url.responsive!"
          fill
          [sizes]="'100vw'"
          [alt]="documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].filename"
          priority
          (click)="imageClicked($event)"
          [ngStyle]="{'transform': 'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scale + ')', 'transition': isZoomed ? 'transform 300ms cubic-bezier(0.1, 0.82, 0.25, 1)' : 'transform 300ms ease-out', 'cursor': isZoomed ? 'zoom-out' : 'zoom-in'}" appNgSrcImageError />
      }

      @if (documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].type === 'image' && documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].mimetype === 'image/gif') {
        <img #imagePreviewElement
          [ngSrc]="documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].url.responsive!"
          fill
          [sizes]="'100vw'"
          [alt]="documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].filename"
          priority
          (click)="imageClicked($event)"
          [ngStyle]="{'transform': 'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scale + ')', 'transition': isZoomed ? 'transform 300ms cubic-bezier(0.1, 0.82, 0.25, 1)' : 'transform 300ms ease-out', 'cursor': isZoomed ? 'zoom-out' : 'zoom-in'}"
          [disableOptimizedSrcset]="true" appNgSrcImageError />
      }

      @if (documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].type === 'video') {
        <video controls autoplay playsinline appVideoSourceError>
          <source [fileName]="documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].url.file" type="video/mp4" src="" appVideoSrc />
          {{ 'BROWSERNOVIDEOSUPPORT' | translate }}
        </video>
      }

      @if (documentService.documentsGalleryPosition > 0) {
        <div class="overlay overlay-left position-absolute d-flex align-items-center justify-content-center cursor-pointer" (click)="step('back')">
          <app-tooltip [text]="'PREVIOUS' | translate" [width]="'auto'" [height]="'auto'">
            <app-form-button [style]="'btn'" [cssClass]="'btn-link px-1'" [iconClass]="'fs-3'" [icon]="'chevron_left'"></app-form-button>
          </app-tooltip>
        </div>
      }

      @if (documentService.documentsGalleryPosition < (documentService.documentsGalleryFiles.length - 1)) {
        <div class="overlay overlay-right position-absolute d-flex align-items-center justify-content-center cursor-pointer" (click)="step('forward')">
          <app-tooltip [text]="'NEXT' | translate" [width]="'auto'" [height]="'auto'">
            <app-form-button [style]="'btn'" [cssClass]="'btn-link px-1'" [iconClass]="'fs-3'" [icon]="'chevron_right'"></app-form-button>
          </app-tooltip>
        </div>
      }
    </div>

    @if (linkDialog) {
      <div class="card imagepreview-iconpopup link-popup position-absolute p-3">
        <app-headline [title]="('GALLERYLINK' | translate)" [type]="'h6'" [class]="'pb-3'"></app-headline>
        <div class="row mb-3">
          <div class="col-md-12">
            <app-form-label [label]="'GALLERYLINK' | translate"></app-form-label>
            <!--<app-form-input [fCN]="'image_link'" [fG]="loginForm" value="https://stage.max-toolbox.com/intranet/detail/13779153" [iconBack]="'content_copy'" [iconClickType]="'back'"></app-form-input>-->
          </div>
        </div>
        <app-headline [title]="('GALLERYADDITIONALOPTIONS' | translate)" [type]="'h6'" [class]="'fs-default fw-bold text-capitalize text-muted pb-2'"></app-headline>
        <div class="row mb-3">
          <div class="col-md-12">
            <app-form-label [label]="'GALLERYEXPIRESAT' | translate"></app-form-label>
            <!--<app-form-date-time [fG]="loginForm" [fCN]="'expiresAt'" [placeholder]="'GALLERYEXPIRESAT' | translate"></app-form-date-time>-->
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <app-form-label [label]="'GALLERYPASSWORDPROTECTION' | translate"></app-form-label>
            <!--<app-form-input [type]="passwordVisible ? 'text' : 'password'" [placeholder]="('GALLERYPASSWORDPROTECTION' | translate)" [errorText]="('GALLERYPASSWORDPROTECTIONREQUIRED' | translate)" [iconFront]="'key'" [iconBack]="passwordVisible ? 'visibility' : 'visibility_off'" [iconClickType]="'back'" [fCN]="'password'" [fG]="loginForm" (iconBackClick)="passwordVisible = !passwordVisible"></app-form-input>-->
          </div>
        </div>
        <div class="d-flex justify-content-end my-2">
          <app-form-button [text]="'GALLERYUPDATELINK' | translate" (click)="updateLink()" [cssClass]="'e-primary fw-semibold'" [iconClass]="'fs-5'"></app-form-button>
        </div>
      </div>
    }

    @if (infoDialog) {
      <div class="card imagepreview-iconpopup info-popup position-absolute p-3">
        <app-headline [title]="('GALLERYPICTUREINFO' | translate)" [type]="'h6'" [class]="'pb-3'"></app-headline>
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center px-1">
            <div class="e-avatar e-avatar-circle e-avatar-small m-1">
              <img src="https://ej2.syncfusion.com/demos/src/grid/images/2.png" alt="profile_pic" width="40" height="40" appNgSrcImageError>
            </div>
          </div>
          <div class="flex-grow-1 lh-1">
            <app-headline [title]="'Stefan Dragosici'" [type]="'h6'" [class]="'text-muted truncate-text-two-lines fs-small'"></app-headline>
            <small class="text-light fs-verysmall">UFU</small>
          </div>
        </div>
        <app-headline [title]="documentService.documentsGalleryFiles[documentService.documentsGalleryPosition].filename!" [type]="'h6'" [class]="'fs-small fw-bold pt-2'"></app-headline>
        <app-headline [title]="'Uploaded: 24 May 2024 13:35'" [type]="'h6'" [class]="'fs-verysmall text-light py-1'"></app-headline>
        <app-headline [title]="'Size: 1.3MB'" [type]="'h6'" [class]="'fs-small text-muted pt-2'"></app-headline>
        <app-headline [title]="'Downloads: 10'" [type]="'h6'" [class]="'fs-small text-muted'"></app-headline>
      </div>
    }
  </div>
</ng-template>
</ejs-dialog>

@if (chatReadsDialog) {
  <app-dialog-chat-reads [(visible)]="chatReadsDialog" [messageId]="currentGalleryMessageId()"></app-dialog-chat-reads>
}
